const ADMIN = 1;
const MARKETER = 2;
const SUPPORT = 3;
const roles = { ADMIN, MARKETER, SUPPORT };
export default roles;
